import React from 'react';
import PropTypes from 'prop-types';
import S from './Tabs.styles';

const Tabs = ({ items, value, onChange }) => (
  <S.Tabs>
    {items.map(i => {
      if (i.link === null) {
        return (
          <S.TabNoLink key={i.id} onClick={e => onChange(i, e)}>
            {i.text}
          </S.TabNoLink>
        );
      }

      return (
        <S.Tab
          key={i.id}
          onClick={e => onChange(i, e)}
          selected={value && value.id === i.id}
          target={i.target || '_self'}
          to={i.link || '#'}
        >
          {i.text}
        </S.Tab>
      );
    })}
  </S.Tabs>
);

Tabs.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  value: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  }),
  onChange: PropTypes.func.isRequired,
};

Tabs.defaultProps = {
  value: null,
};

export default React.memo(Tabs);
